import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  state: {
    user: JSON.parse(localStorage.getItem('user')) || null,
    token: localStorage.getItem('access_token') || null,
  },
  mutations: {
    UPDATE_USER(state, { user }) {
      state.user = user
    },
    UPDATE_TOKEN(state, { token }) {
      state.token = token
    },
  },
  actions: {
    // async FETCH_USER({ commit }) {
    //   try {
    //     let { data } = await Vue.prototype.$http.get('/api/auth/getuser')
    //     commit('UPDATE_USER', { user: data.data })
    //   } catch (error) { console.log(error) }
    // },
  },
  getters: {
    user: state => state.user,
    token: state => state.token,
  },
}
